import * as React from "react";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { createAdminUser } from "../Apihelper/ApiHelperUser";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from "../Includes/Header";
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { useState } from "react";
import { useEffect, useRef } from "react";
import {
  Card,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
  Stack,
  Breadcrumbs,
  Link,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Menu from "@mui/material/Menu";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";

import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";

import {
  retrieveOfferMember,
  offerPackageDropdown,
  createOfferPackageUser,
  AutoNonMembershipNumber,
  Nonregistervalue,
} from "../Apihelper/ApiOfferPackage";

import { useNavigate } from "react-router-dom";
import AppToast from '../../components/Toast/AppToast';
import { generateCardNumber } from '../../utils/generateCardNumber';

const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));
const drawerWidth = 292;

function AddUser(props) {
  const { colors: appColors } = useAppTheme();
  const navigate = useNavigate();
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [submitted, setSubmitted] = useState(false);

  const dateRef = useRef();

  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );

  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  // useEffect(() => {
  //   // Perform localStorage action
  //   const item = localStorage.getItem('userdata')
  //   if (item ==null){
  //      setredirectpage(true);
  //   }
  //   //console.log("tapan"+item);
  // }, [])
  // if (redirectpage) {

  //   return redirect('/');
  // }

  const drawer = (
    <div className="d-flex flex-column h-100">
      <Header />
    </div>
  );
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      border: 0,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Default to 'success'
  const [Dropdowndata, setDropdowndata] = useState([]); // Default to 'success'

  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [UseradminData, setUseradminData] = useState({
    membershipnumber: "",
    fullname: "",
    email: "",
    phone: "",
    batchnumber: "",
    package: "",
    discount: "",
    payingamount: "",
    payableamount: "",
    dateofpayment: dayjs(),
  });
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUseradminData({
      ...UseradminData,
      [name]: name === "email" ? value.toLowerCase() : name === "fullname" ? value.toUpperCase() : value, // Ensure email is always lowercase and full name is always uppercase
    });
  };
  
  

  const handleSubmit = async () => {
    // console.log(UseradminData);
    setSubmitted(true);
    // console.log(UseradminData);
    const requiredFields = [
      "fullname",
      "phone",
      "email",
      "package",
      "payableamount",
      "payingamount",
      "dateofpayment",
    ];
    const emptyFields = requiredFields.filter((field) => !UseradminData[field]);
    if (emptyFields.length > 0) {
      // Show error for empty fields

      return;
    }
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;

    const batchnumber = UseradminData.batchnumber || generateCardNumber();
    if (!UseradminData.batchnumber) {
      setUseradminData((prev) => ({ ...prev, batchnumber }));
    }

    try {
      const payload = { ...UseradminData, batchnumber };
      const res = await createOfferPackageUser(userToken, payload);
      if (res.code == "200") {
        handleSnackbarOpen(res.message, "success");
        setUseradminData({
          membershipnumber: "",
          fullname: "",
          email: "",
          phone: "",
          batchnumber: "",
          package: "",
          discount: "",
          payingamount: "",
          payableamount: "",
          dateofpayment: dayjs(),
        });
        navigate("/ParentOfferPackage");
      } else {
        handleSnackbarOpen(res.message, "error");
        //   console.error(error); // Handle error
      }
    } catch (error) {
      console.error(error); // Handle error
    }
  };
  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      // User is not logged in, no need to redirect
      navigate('/');
    }
    
  }, []);
  const fetchData = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await AutoNonMembershipNumber(userToken, userId);

      if (res.code == "200") {
        setUseradminData((prev) => ({ ...prev, membershipnumber: res.data }));
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  const fetchDropdowndata = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await offerPackageDropdown(userToken, userId);

      if (res.code == "200") {
        setDropdowndata(res.data);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  useEffect(() => {
    fetchDropdowndata();
    fetchData();
    setUseradminData((prev) => ({ ...prev, batchnumber: generateCardNumber() }));
  }, []);
  // const handlepayblevalueChange = async (e) => {
  //   // Update state with the selected package
  //   const selectedPackageId = e.target.value;
  //   setUseradminData({ ...UseradminData, package: selectedPackageId });
  // };
  const handlepayblevalueChange = async (e) => {
    // Update state with the selected package
    const selectedPackageId = e.target.value;
    const selectedPackage = Dropdowndata.find((row) => row.id === selectedPackageId);
  console.log(selectedPackage)
  setUseradminData({ ...UseradminData, package: selectedPackageId,packagename:selectedPackage?.name || '', });
  
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id; 
      const res = await Nonregistervalue(userToken, userId, selectedPackageId);
  
      if (res.code == "200") {
      
          // Extract the package_amount from the first object in the array
          const packageAmount = res.data.value;
          setUseradminData(prevState => ({
            ...prevState,
            payableamount: packageAmount
          }));
         
        
          
        
      } else {
         // handleSnackbarOpen(res.message, 'error');
         console.error(error); 
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      // Handle error if necessary
    }
  };
  useEffect(() => {
    const payableAmount = parseFloat(UseradminData.payableamount) || 0;
    const discount = parseFloat(UseradminData.discount) || 0;

    // Calculate the paying amount
    const payingAmount = payableAmount - discount;

    // Update the paying amount in state
    setUseradminData((prevData) => ({
      ...prevData,
      payingamount: payingAmount >= 0 ? payingAmount : 0, // Ensure it's not negative
    }));
  }, [UseradminData.payableamount, UseradminData.discount]);

  const isMobile = useMediaQuery('(max-width:600px)');

  const fieldSx = {
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      '&:hover fieldset': { borderColor: appColors.evergreen },
      '&.Mui-focused fieldset': { borderColor: appColors.evergreen },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: appColors.evergreen },
  };

  return (
    <Box
      sx={{ display: "flex", backgroundColor: "#EFEDF1", minHeight: "100vh" }}
    >
      <Header />
      <CssBaseline />
      <Box
        component="main"
        sx={{ flexGrow: 1, overflowY: "auto", padding: "20px" }}
      > 
        <div style={{ display: "flex", flexGrow: 1, marginTop: "50px" }}>
          <div style={{ flex: 1, marginTop: "15px" }}>
            <Card sx={{ p: { xs: 2, sm: 3 }, mb: 3, borderRadius: 2, boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
              <Stack 
                direction={{ xs: 'column', sm: 'row' }} 
                alignItems={{ xs: 'stretch', sm: 'center' }} 
                justifyContent="space-between"
                spacing={2}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  <IconButton
                    onClick={() => navigate(-1)}
                    sx={{
                      bgcolor: appColors.evergreen,
                      color: 'white',
                      '&:hover': { bgcolor: appColors.pine },
                    }}
                  >
                    <ArrowBackIcon />
                  </IconButton>
                  <Box>
                    <Typography variant="h5" sx={{ color: appColors.evergreen, fontWeight: 600 }}>
                      Add Non-Member
                    </Typography>
                    <Breadcrumbs sx={{ mt: 0.5 }}>
                      <Link 
                        underline="hover" 
                        color="inherit" 
                        sx={{ cursor: 'pointer' }}
                        onClick={() => navigate('/dashboard')}
                      >
                        Home
                      </Link>
                      <Link
                        underline="hover"
                        color="inherit"
                        sx={{ cursor: 'pointer' }}
                        onClick={() => navigate('/ParentOfferPackage')}
                      >
                        Members
                      </Link>
                      <Typography color="text.primary">Add Non-Member</Typography>
                    </Breadcrumbs>
                  </Box>
                </Stack>
                <Button
                  fullWidth={isMobile}
                  variant="contained"
                  onClick={() => navigate('/ParentOfferPackage')}
                  sx={{
                    bgcolor: appColors.evergreen,
                    '&:hover': { bgcolor: appColors.pine },
                    textTransform: 'none',
                    px: 3,
                    py: 1,
                    borderRadius: 2,
                    fontWeight: 600,
                  }}
                >
                  View List
                </Button>
              </Stack>
            </Card>

            <Card sx={{
              mt: 2,
              mb: 3,
              borderRadius: 3,
              boxShadow: '0 2px 16px rgba(27,67,50,0.10)',
              overflow: 'hidden',
            }}>
              {/* Section: Personal Info */}
              <Box sx={{ px: { xs: 2, sm: 3 }, pt: 3, pb: 1 }}>
                <Typography variant="overline" sx={{ color: appColors.evergreen, fontWeight: 700, letterSpacing: 1.5, fontSize: '0.7rem' }}>
                  Personal Information
                </Typography>
                <Box sx={{ borderBottom: '2px solid #e8f5e9', mt: 0.5, mb: 2.5 }} />
                <Grid container spacing={2.5}>
                  <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                      name="membershipnumber"
                      label="Membership Number"
                      fullWidth
                      inputProps={{ readOnly: true }}
                      value={UseradminData.membershipnumber}
                      onChange={handleChange}
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                      name="fullname"
                      label="Full Name"
                      fullWidth
                      placeholder="Enter full name"
                      value={UseradminData.fullname}
                      onChange={handleChange}
                      error={submitted && !UseradminData.fullname}
                      helperText={submitted && !UseradminData.fullname && "Name is required"}
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                      name="phone"
                      label="Phone"
                      type="number"
                      fullWidth
                      placeholder="Enter phone number"
                      value={UseradminData.phone}
                      onChange={handleChange}
                      error={submitted && !UseradminData.phone}
                      helperText={submitted && !UseradminData.phone && "Phone is required"}
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                      name="email"
                      label="Email"
                      fullWidth
                      placeholder="Enter email address"
                      value={UseradminData.email}
                      onChange={handleChange}
                      error={submitted && !UseradminData.email}
                      helperText={submitted && !UseradminData.email && "Email is required"}
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                      name="batchnumber"
                      label="Card Number"
                      fullWidth
                      placeholder="Enter card number"
                      value={UseradminData.batchnumber}
                      onChange={handleChange}
                      sx={fieldSx}
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* Section: Package & Payment */}
              <Box sx={{ px: { xs: 2, sm: 3 }, pt: 2.5, pb: 1 }}>
                <Typography variant="overline" sx={{ color: appColors.evergreen, fontWeight: 700, letterSpacing: 1.5, fontSize: '0.7rem' }}>
                  Package & Payment
                </Typography>
                <Box sx={{ borderBottom: '2px solid #e8f5e9', mt: 0.5, mb: 2.5 }} />
                <Grid container spacing={2.5}>
                  <Grid size={{ xs: 12, sm: 4 }}>
                    <FormControl fullWidth error={submitted && !UseradminData.package} sx={fieldSx}>
                      <InputLabel id="package-label">Package</InputLabel>
                      <Select
                        labelId="package-label"
                        label="Package"
                        value={UseradminData.package}
                        onChange={handlepayblevalueChange}
                      >
                        {Dropdowndata.map((row) => (
                          <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
                        ))}
                      </Select>
                      {submitted && !UseradminData.package && (
                        <FormHelperText>Package is required</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 4 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={UseradminData.dateofpayment}
                        onChange={(date) => setUseradminData({ ...UseradminData, dateofpayment: date })}
                        label="Date of Payment"
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: submitted && !UseradminData.dateofpayment,
                            helperText: submitted && !UseradminData.dateofpayment && "Date of Payment is required",
                            sx: fieldSx,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                      label="Payable Amount"
                      fullWidth
                      placeholder="0.00"
                      value={UseradminData.payableamount}
                      error={submitted && !UseradminData.payableamount}
                      helperText={submitted && !UseradminData.payableamount && "Payable Amount is required"}
                      onChange={(e) => setUseradminData({ ...UseradminData, payableamount: e.target.value })}
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                      label="Discount / Offer"
                      fullWidth
                      placeholder="0.00"
                      value={UseradminData.discount}
                      onChange={(e) => setUseradminData({ ...UseradminData, discount: e.target.value })}
                      sx={fieldSx}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField
                      label="Paying Amount"
                      fullWidth
                      placeholder="0.00"
                      value={UseradminData.payingamount}
                      error={submitted && !UseradminData.payingamount}
                      helperText={submitted && !UseradminData.payingamount && "Paying Amount is required"}
                      onChange={(e) => setUseradminData({ ...UseradminData, payingamount: e.target.value })}
                      sx={fieldSx}
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* Action Buttons */}
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: 2,
                px: { xs: 2, sm: 3 },
                py: 3,
                mt: 1,
                borderTop: '1px solid #f0f4f0',
                flexDirection: { xs: 'column', sm: 'row' },
              }}>
                <Button
                  startIcon={<CancelIcon />}
                  variant="outlined"
                  type="reset"
                  sx={{
                    color: appColors.evergreen,
                    borderColor: appColors.evergreen,
                    '&:hover': { borderColor: appColors.pine, bgcolor: 'rgba(27,67,50,0.04)' },
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 2,
                    px: 3,
                    width: { xs: '100%', sm: 'auto' },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  startIcon={<CheckCircleIcon />}
                  sx={{
                    bgcolor: appColors.evergreen,
                    '&:hover': { bgcolor: appColors.pine },
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 2,
                    px: 3,
                    width: { xs: '100%', sm: 'auto' }
                  }}
                  variant="contained"
                  onClick={handleSubmit}
                >
                  Add Member
                </Button>
              </Box>
            </Card>
          </div>
        </div>
      </Box>

      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </Box>
  );
}

export default AddUser;